<template>
  <neo-hero @scroll="scroll" />
  <neo-about id="about" />
  <neo-how-it-works id="how-it-works" />
  <neo-faqs id="faqs" />
  <neo-exclusive-access />
  <neo-footer id="contact" />
</template>

<script>
import NeoHero from "@/components/Website/NeoHero";
import NeoAbout from "@/components/Website/NeoAbout";
import NeoHowItWorks from "@/components/Website/NeoHowItWorks";
import NeoFaqs from "@/components/Website/NeoFaqs.vue";
import NeoExclusiveAccess from "@/components/Website/NeoExclusiveAccess.vue";
// import NeoEarlyAccess from "@/components/Website/NeoEarlyAccess";
import NeoFooter from "@/components/Website/NeoFooter";

export default {
  name: "Index",
  components: {
    NeoExclusiveAccess,
    NeoFaqs,
    NeoFooter,
    // NeoEarlyAccess,
    NeoHowItWorks,
    NeoAbout,
    NeoHero,
  },
  data() {
    return {};
  },
  methods: {
    scroll(section) {
      document.getElementById(section).scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>
